module.exports = __webpack_public_path__ + "static/img/bg_2.056b175.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_2.png
// module id = 784
// module chunks = 1